import { Command } from '@/app/common/base/command'

export class SubmitIwizeInventoryFormCommand extends Command {
    public async run(data: FormData, productActionId: string) {
        await this.client.multiPart(`/api/inventory-form/iwize/${productActionId}`, data)
    }
}
